import React, { useEffect, useState } from "react";
import api, { img } from "../../lib/api";
import { AdminHeader } from "./AdminLayout";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";

export default function AdminCollections() {
  const [cols, setCols] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/collections").then(r => setCols(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (edit.id) await api.put(`/admin/collections/${edit.slug}`, edit);
    else await api.post("/admin/collections", edit);
    toast.success("Saved"); setEdit(null); load();
  };
  const del = async (c) => { if (!window.confirm("Delete collection?")) return; await api.delete(`/admin/collections/${c.slug}`); load(); };
  return (
    <div>
      <AdminHeader title="Collections" action={<button onClick={() => setEdit({ title: "", slug: "", kind: "special", description: "", banner: "" })} className="btn-primary flex items-center gap-2"><Plus size={15} /> New</button>} />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cols.map((c) => (
          <div key={c.slug} className="bg-white border border-sage/30 rounded-sm overflow-hidden">
            <img src={img(c.banner)} alt="" className="h-28 w-full object-cover" />
            <div className="p-4"><div className="serif text-xl">{c.title}</div><div className="text-xs text-forest/50 mb-2">{c.kind} · /{c.slug}</div>
              <div className="flex gap-2"><button onClick={() => setEdit(c)} className="text-xs underline">Edit</button><button onClick={() => del(c)} className="text-xs underline text-brown">Delete</button></div></div>
          </div>
        ))}
      </div>
      {edit && (
        <div className="fixed inset-0 z-[80]"><div className="absolute inset-0 bg-forest/40" onClick={() => setEdit(null)} />
          <div className="absolute right-0 top-0 bottom-0 w-full max-w-md bg-ivory p-6 overflow-auto">
            <div className="flex justify-between mb-6"><h2 className="serif text-3xl">Collection</h2><button onClick={() => setEdit(null)}><X size={22} /></button></div>
            <div className="space-y-4">
              <I label="Title" v={edit.title} on={(v) => setEdit({ ...edit, title: v })} />
              <I label="Slug" v={edit.slug} on={(v) => setEdit({ ...edit, slug: v })} />
              <div><label className="text-xs uppercase text-forest/55">Kind</label><select className="w-full border border-sage/40 px-3 py-2 mt-1 rounded-sm bg-white" value={edit.kind} onChange={(e) => setEdit({ ...edit, kind: e.target.value })}><option value="special">special</option><option value="category">category</option></select></div>
              <div><label className="text-xs uppercase text-forest/55">Description</label><textarea className="w-full border border-sage/40 px-3 py-2 mt-1 rounded-sm" rows={3} value={edit.description} onChange={(e) => setEdit({ ...edit, description: e.target.value })} /></div>
              <I label="Banner URL" v={edit.banner} on={(v) => setEdit({ ...edit, banner: v })} />
              <button onClick={save} className="btn-primary w-full">Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
const I = ({ label, v, on }) => <div><label className="text-xs uppercase text-forest/55">{label}</label><input value={v ?? ""} onChange={(e) => on(e.target.value)} className="w-full border border-sage/40 px-3 py-2 mt-1 rounded-sm bg-white text-sm" /></div>;
